import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Trfa911FTPUploadHistoryModel } from 'src/Models/TRFA_911_FTPUploadHistoryModel';
import * as FileSaver from 'file-saver';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ActionActivity } from 'src/Models/Common';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ToastrService } from 'ngx-toastr';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { Title } from '@angular/platform-browser';
import { FilterModel } from 'src/Models/filterModel';
import { EmailLoginService } from 'src/Services/emaillogin.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-downloadfilesonboarding',
  templateUrl: './downloadfilesonboarding.component.html',
  styleUrls: ['./downloadfilesonboarding.component.css']
})
export class DownloadfilesonboardingComponent implements OnInit {

  userid: number = 0;
  ListHistoryModel: Trfa911FTPUploadHistoryModel[] = [];
  isloading: boolean = true;
  isShowprogressSpinner: boolean = false;
  blockedDocument: boolean = false;
  DownloadLink: string = '';
  tokenKey: any;
  clientInformationId: number = 0;
  priceQuoteId: number = 0;

  quaryValues: string = '';
  filterModel = new FilterModel();

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly appActivity: ApplicationActivityService,
    private readonly toastr: ToastrService,
    private readonly PricingQuotesMaster: PricingQuotesService,
    private readonly htmlToPdf: HtmlToPdf,
    private readonly titleService: Title,
    private readonly emailLoginService: EmailLoginService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey =  this.sessionStorageService.getTokenValue()
    this.titleService.setTitle('Quotes And Onboarding Download | JSi360');
  }

  ngOnInit() {
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.quaryValues = params['id'];
          this.filterModel.emailKey = params['id'];
          this.IsValidOnboardingQuoteEmailKey();
        }
        else {
          this.router.navigate(['login/' + this.quaryValues]);
        }
      }
      else {
        this.router.navigate(['login/' + this.quaryValues]);
      }
    });
  }

  IsValidOnboardingQuoteEmailKey() {
    this.blockedDocument = true;
    this.emailLoginService.isValidOnboardingQuoteEmailKey(this.filterModel).subscribe(
      data => {
        this.blockedDocument = false;
        sessionStorage.setItem('emailOnboardingQuoteUId', data.userId);

        const userName = this.sessionStorageService.getUserName();

        if (data.status === 'Success' && userName !== null && userName !== undefined && userName.trim() !== '') {
          this.clientInformationId = data.clientInformationId;
          this.priceQuoteId = data.priceQuoteId;
          this.downloadOnboardingdetails();
        }
        else if (data.status == 'Success') {
          this.router.navigate(['login/' + this.quaryValues]);
        }
        else if (data.status == 'Expired' && userName !== null && userName !== undefined && userName.trim() !== '') {
          var Urldata = 'Access/Denied/' + decodeURI('Quotes-and-Onboarding');
          this.router.navigate([Urldata]);
        }
        else
          this.router.navigate(['login']);

      },
      error => {
        this.blockedDocument = false;
        console.log(error);
        this.router.navigate(['login']);
      }
    );
  }

  downloadOnboardingdetails() {
    this.blockDocument();
    this.applicationActivity('Download', 'On boarding - File', ActionActivity['Onboarding'], this.quaryValues, this.clientInformationId);
    this.PricingQuotesMaster.GenerateOnboardingDetails(this.clientInformationId, this.priceQuoteId, "").subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.downloadFile('OnboardingDetails.pdf', data['url'], data['fileName']);
        }

        this.unblockDocument();
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  buttonclick() {
    this.downloadOnboardingdetails();
  }


  public downloadFile(filename: any, url: any, orignalFileName: any) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        sessionStorage.setItem('fileloading', 'false');
        this.htmlToPdf.DeletePDF(this.tokenKey, orignalFileName).subscribe(
          data => {
            this.unblockDocument();
          },
        );
      }
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;

  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  applicationActivity(actionName: any, pageName: any, datatype = 0, actionUrl = '', dataId = 0) {
    ApplicationActivityStore(actionName, pageName, this.appActivity, dataId, datatype, actionUrl)
  }
}